export const FEATURE = {
  // Launch-safe core loops.
  // Keep these boolean-only. Do not use string feature keys here; route guards and upload hooks
  // rely on real booleans.
  FISHIQ: true,
  OCR: true,
  AR: false,
  TOURNAMENTS: false,

  // Bazaar classifieds are live. Real-money checkout stays separately gated until release review.
  BAZAAR_ENABLED: true,
  // Local/direct Bazaar remains the only supported checkout mode while Stripe is staged.
  BAZAAR_LISTINGS_ONLY: true,
  // Hard client gate for Stripe Checkout, transaction history/receipts, escrow, and payouts.
  BAZAAR_PAYMENTS_ENABLED: false,

  // Ads: rewarded Search Lures are production-enabled with SSV.
  // Baleen Bay native/feed ads remain independently gated OFF.
  ADS_ENABLED: true,
  ADS_TEST_MODE: false,
  BALEEN_BAY_NATIVE_ADS_ENABLED: false,
  REWARDED_SEARCH_LURE_ADS_ENABLED: true,

  // Social foundation: friends/crew and sharing are launch-safe; DM UI stays gated.
  FRIENDS_CREW_ENABLED: true,
  SHARING_ENABLED: true,
  MESSAGING_ENABLED: false,
} as const;

export const FEATURES = {
  ...FEATURE,

  // Cost guards: keep FishIQ browse/search local-first.
  // Turn these on only after the backend cache/import layer is verified.
  FISHIQ_FIRESTORE_SPECIES_OVERLAY: false,
  FISHIQ_REMOTE_ENRICHMENT: false,
  FISHIQ_LIVE_SIGNALS: true,
  FISHIQ_PUBLIC_SOURCE_REGISTRY: false,

  // Audited remote species reference images. Safe to enable with an empty manifest;
  // cards/details fall back to the existing species emoji until references are added.
  FISHIQ_VISUAL_REFERENCES: true,

  // Keep scanner evidence OFF until the photo scanner is moved server-side and
  // explicitly consumes only scannerEligible audited references.
  FISHIQ_SCANNER_REFERENCE_EVIDENCE: false,
} as const;

export type FeatureKey = keyof typeof FEATURES;
